import { History, Utensils } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const HistoryModal = ({
  showHistory,
  setShowHistory,
  recipeHistory,
  setRecipeHistory,
  setSelectedRecipe,
}) => {
  return (
    <Dialog open={showHistory} onOpenChange={setShowHistory}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-auto bg-[#FEFAE0] border-0 p-0 rounded-3xl" aria-describedby={undefined}>
        <div className="p-6" data-testid="history-modal">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#264653] flex items-center gap-2">
              <History className="w-6 h-6 text-[#2A9D8F]" />
              Recipe History
            </DialogTitle>
          </DialogHeader>

          {recipeHistory.length === 0 ? (
            <div className="text-center py-8">
              <History className="w-12 h-12 text-[#264653]/20 mx-auto mb-3" />
              <p className="text-[#264653]/60">No recipe history yet</p>
              <p className="text-sm text-[#264653]/40 mt-1">Your generated recipes will appear here</p>
            </div>
          ) : (
            <div className="space-y-4 mt-4">
              {recipeHistory.map((entry, index) => (
                <div key={entry.id} className="bg-white rounded-2xl p-4 border-2 border-[#264653]/10" data-testid={`history-entry-${index}`}>
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs text-[#264653]/50">
                      {new Date(entry.createdAt).toLocaleDateString()} at {new Date(entry.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                    <span className="text-xs font-medium text-[#2A9D8F] capitalize bg-[#2A9D8F]/10 px-2 py-1 rounded-full">
                      {entry.vibe}
                    </span>
                  </div>
                  {entry.diets && entry.diets.length > 0 && (
                    <div className="flex gap-1 mb-3">
                      {entry.diets.map(diet => (
                        <span key={diet} className="text-xs bg-[#264653]/10 text-[#264653] px-2 py-0.5 rounded-full capitalize">
                          {diet}
                        </span>
                      ))}
                    </div>
                  )}
                  <div className="space-y-2">
                    {entry.recipes.map((recipe) => (
                      <div
                        key={recipe.id}
                        className="flex items-center gap-3 p-2 rounded-xl hover:bg-[#FEFAE0] cursor-pointer"
                        onClick={() => { setSelectedRecipe(recipe); setShowHistory(false); }}
                      >
                        {recipe.image_url ? (
                          <img src={recipe.image_url} alt={recipe.title} className="w-12 h-12 rounded-lg object-cover" />
                        ) : (
                          <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#FFB703]/20 to-[#2A9D8F]/20 flex items-center justify-center">
                            <Utensils className="w-5 h-5 text-[#264653]/30" />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <h5 className="font-medium text-sm text-[#264653] truncate">{recipe.title}</h5>
                          <span className="text-xs text-[#264653]/50">{recipe.time_minutes} min • {recipe.calories} cal</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {recipeHistory.length > 0 && (
            <button
              onClick={() => {
                setRecipeHistory([]);
                localStorage.removeItem("moodfood_recipe_history");
                toast.success("History cleared");
              }}
              className="w-full mt-4 py-2 text-sm text-[#E76F51] hover:bg-[#E76F51]/10 rounded-xl"
              data-testid="clear-history-btn"
            >
              Clear History
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
